// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import InfoRoundSvg from '@rsuite/icon-font/lib/status/InfoRound';
var InfoRound = createSvgIcon({
  as: InfoRoundSvg,
  ariaLabel: 'info round',
  category: 'status',
  displayName: 'InfoRound'
});
export default InfoRound;